/* GSH lightbox — original lightweight image zoom (replaces PhotoSwipe dependency). */
(function(){
  'use strict';
  document.addEventListener('click', function(e){
    var img = e.target.closest('[data-gsh-zoomable] img');
    if (!img) return;
    var overlay = document.createElement('div');
    overlay.className = 'gsh-lightbox';
    overlay.innerHTML = '<img src="'+img.currentSrc+'" alt="'+(img.alt||'')+'"><button aria-label="Zapri" class="gsh-lightbox__close">✕</button>';
    document.body.appendChild(overlay);
    requestAnimationFrame(function(){ overlay.classList.add('is-open'); });
    function close(){ overlay.classList.remove('is-open'); setTimeout(function(){ overlay.remove(); }, 250); }
    overlay.addEventListener('click', function(ev){ if (ev.target===overlay || ev.target.closest('.gsh-lightbox__close')) close(); });
    document.addEventListener('keydown', function esc(ev){ if (ev.key==='Escape'){ close(); document.removeEventListener('keydown', esc); } });
  });
})();
